import { useMutation } from 'react-query';
import { queryClient } from '../../../../config/queryClient';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { MonteCarloPercentilesDTO } from '../types/monteCarlo.types';

export interface BodyParams {
  AllocateExcessCashflow: boolean;
  AllocatedCashflow: number;
  GoalId: string;
  IsInvalidated: boolean;
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
}

export interface Params {
  clientId: number;
  fpId: string | null;
  body: BodyParams;
  signal?: AbortSignal;
}

export const saveMarketScenariosWhatIfs = ({
  clientId,
  fpId,
  body,
  signal,
}: Params): Promise<MonteCarloPercentilesDTO> => {
  return authFetch(
    urlWithParams(`/Consumer/MC/Percentiles`, {
      clientId,
      fpId,
    }),
    {
      method: 'POST',
      ...httpBodyOptions(body, true),
      signal,
    },
  );
};

interface QueryParams {
  clientId: number;
  fpId: string;
}

export const useMarketScenariosWhatIfsMutation = ({ clientId, fpId }: QueryParams) => {
  return useMutation(saveMarketScenariosWhatIfs, {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.marketScenarios(clientId, fpId), {
        refetchActive: true,
        refetchInactive: true,
      });
    },
  });
};
